var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn_box"},[_c('a',{staticClass:"btn__view-plan",attrs:{"href":""},on:{"click":function($event){$event.preventDefault();return _vm.openMap()}}},[_vm._v("ver plano a detalle")])])}
var staticRenderFns = []

export { render, staticRenderFns }